import {Navigate} from 'react-router-dom'

export default function PrivateRouter({children}){
    const role = localStorage.getItem('user_role')

    return !!role ? children : <Navigate to="/" />
}
